import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/login.vue'
import HomePage from '../views/index.vue'
import CategoryPage from '../views/category.vue'
import TprPage from '../views/tpr.vue'
import FlashPage from '../views/flash.vue'
import WordPage from '../views/word.vue'
import TprFullscreenPage from '../views/tpr-fullscreen.vue'
import FullscreenPage from '../views/fullscreen.vue'
import VideosPage from '../views/videos.vue'
import AudiosPage from '../views/audios.vue'
import AudioPage from '../views/audio.vue'
import PlayerPage from '../views/player.vue'
import ActivatePage from '../views/activate.vue'
import RegisterPage from '../views/register.vue'
import VipPage from '../views/vip.vue'
import HistoryPage from '../views/history.vue'
import ParentalPage from '../views/parental.vue'
import PreferencePage from '../views/preference.vue'
import PaySuccessPage from '../views/pay-success.vue'
import MyProfilePage from '../views/myprofile.vue'

const AUTH_STORAGE_KEY = 'ACCESS_TOKEN'
const PARENT_VERIFIED_STORAGE_KEY = 'tree-sprout-parent-verified'
const PUBLIC_PATHS = ['/login', '/activate', '/pay-success']

const isPublicPath = (path) => {
  return PUBLIC_PATHS.includes(path) || path.startsWith('/activate/')
}

const routes = [
  { path: '/', component: HomePage },
  { path: '/login', component: LoginPage },
  { path: '/register', component: RegisterPage },
  { path: '/category', component: CategoryPage },
  { path: '/tpr', component: TprPage },
  { path: '/flash', component: FlashPage },
  { path: '/word', component: WordPage },
  { path: '/tpr-fullscreen', component: TprFullscreenPage },
  { path: '/fullscreen', component: FullscreenPage },
  { path: '/videos', component: VideosPage },
  { path: '/audios', component: AudiosPage },
  { path: '/audio', component: AudioPage },
  { path: '/player', component: PlayerPage },
  { path: '/activate/:code?', component: ActivatePage },
  { path: '/vip', component: VipPage },
  { path: '/history', component: HistoryPage },
  { path: '/parental', component: ParentalPage },
  { path: '/preference', component: PreferencePage },
  { path: '/pay-success', component: PaySuccessPage },
  { path: '/myprofile', component: MyProfilePage }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  const isAuthenticated = window.localStorage.getItem(AUTH_STORAGE_KEY) !== null
  // if (!isPublicPath(to.path) && !isAuthenticated) {
  //   return '/login'
  // }

  if (to.path === '/login' && isAuthenticated) {
    return '/'
  }

  if (to.path === '/parental' && window.sessionStorage.getItem(PARENT_VERIFIED_STORAGE_KEY) !== '1') {
    return '/'
  }

  return true
})

export default router
